import { render, staticRenderFns } from "./ajaxcontent.vue?vue&type=template&id=2533555c"
import script from "./ajaxcontent.vue?vue&type=script&lang=js"
export * from "./ajaxcontent.vue?vue&type=script&lang=js"
import style0 from "./ajaxcontent.vue?vue&type=style&index=0&id=2533555c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports